"use client";

import { Box, Typography } from "@mui/material";
import dynamic from "next/dynamic";
import ActionButton from "@/src/components/common/broadsheet/action-button";
import ErrorMark from "@/src/components/common/broadsheet/error-mark";
import Kicker from "@/src/components/common/broadsheet/kicker";
import {
  doubleRule,
  FONT_DISPLAY,
  FONT_TEXT,
  HEADING_SIZE,
  SHEET_GUTTER,
  SHEET_MAX_WIDTH,
} from "@/src/components/common/broadsheet/tokens";

const JournalsSection = dynamic(
  () =>
    import("@/src/components/main-site/home/journals-section/journals-section"),
);

export default function Error404() {
  return (
    <Box
      component="main"
      sx={{ maxWidth: SHEET_MAX_WIDTH, mx: "auto", px: SHEET_GUTTER }}
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1fr 22rem" },
          alignItems: "center",
          columnGap: 2.5,
          rowGap: 1.5,
          py: { xs: 2, md: 3 },
          ...doubleRule,
          "& > *": { minWidth: 0 },
        }}
      >
        <Box>
          <Kicker sx={{ mb: 0.375 }}>Page not found</Kicker>
          <Typography
            component="h1"
            sx={{
              m: 0,
              fontFamily: FONT_DISPLAY,
              fontWeight: 700,
              fontSize: HEADING_SIZE.page,
              lineHeight: 1.05,
              letterSpacing: "0.01em",
              color: "custom.ink",
            }}
          >
            This page has gone to press without us
          </Typography>
          <Typography
            component="p"
            sx={{
              m: 0,
              mt: 0.5,
              fontFamily: FONT_TEXT,
              fontSize: { xs: "0.9375rem", md: "1rem" },
              lineHeight: 1.6,
              color: "custom.inkMuted",
              maxWidth: "52ch",
            }}
          >
            The address you followed does not match anything we publish. It may
            have moved, or the link may have been mistyped.
          </Typography>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, mt: 1.25 }}>
            <ActionButton href="/">Return home</ActionButton>
            <ActionButton href="/journal-finder" variant="outline">
              Browse the journals
            </ActionButton>
            <ActionButton href="/search" variant="outline">
              Search the archive
            </ActionButton>
          </Box>
        </Box>
        <ErrorMark code="404" label="Not found" />
      </Box>

      <Box sx={{ py: { xs: 1.5, md: 2 } }}>
        <JournalsSection />
      </Box>
    </Box>
  );
}
